import React, { useEffect, useState } from 'react'

type QueueTimeData = {
  openingTime: {
    from: string
    to: string
  }
  waitingTime: string
  waitingMin: string
  waitingTextDe: string
  waitingTextEn: string
}
export default function LiveQueueTime() {
  const [openingHours, setOpeningHours] = useState('')
  // const [queueTime, setQueueTime] = useState('')

  function getCurrentQueueTime() {
    fetch('https://api.miniatur-wunderland.de/v1/current/', {
      method: 'GET',
      mode: 'cors',
    })
      .then((response) => {
        response
          .json()
          .then((data: QueueTimeData) => {
            setOpeningHours(data.openingTime.from + ' - ' + data.openingTime.to)
            // setQueueTime(
            //   window.jsProps.lang === 'de'
            //     ? data.waitingTextDe
            //     : data.waitingTextEn,
            // )
          })
          .catch((_e) => {
            console.warn('Could not get current queue time')
          })
      })
      .catch((_e) => {
        console.warn('Could not get current queue time')
      })
  }

  useEffect(() => {
    getCurrentQueueTime()
    setTimeout(() => getCurrentQueueTime(), 50000)
  }, [])

  return (
    <div className="LiveQueueTime">
      <a
        href={window.jsProps.urls.openingHours}
        className="LiveQueueTime__OpeningHours"
      >
        <div className="LiveQueueTime__OpeningHoursLabel">
          {window.jsProps.strings.openingHoursToday}
        </div>
        <div className="LiveQueueTime__OpeningHoursValue">
          {openingHours} Uhr
        </div>
      </a>
      {/* <a
        href={window.jsProps.urls.waitingTimes}
        className="LiveQueueTime__QueueTime"
      >
        <div className="LiveQueueTime__QueueTimeLabel">
          {window.jsProps.strings.currentQueueTime}
        </div>
        <div className="LiveQueueTime__QueueTimeValue">{queueTime}</div>
      </a> */}
    </div>
  )
}
